<template>
  <div class="block" style="margin-bottom: -6px">
    <video
      src="../assets/videos/hands.mp4"
      autoplay
      loop
      muted
      defaultMuted
      playsinline
    ></video>

    <div class="container position-absolute top-50 start-50 translate-middle">
      <h1 class="text-center header-title pb-5">Unsere Kompetenzen</h1>

      <div
        id="accordionFlushCompetenceHoerbuch"
        class="accordion accordion-flush"
      >
        <!-- Loop -->
        <div
          v-for="(skill, index) in skills"
          :key="index"
          class="accordion-item"
        >
          <h2 class="accordion-header" :id="'flush-heading' + index">
            <button
              class="accordion-button collapsed"
              data-bs-toggle="collapse"
              :data-bs-target="'#flush-collapse' + index"
              aria-expanded="false"
              :aria-controls="'flush-collapse' + index"
            >
              {{ skill.header }}
            </button>
          </h2>
          <div
            :id="'flush-collapse' + index"
            class="accordion-collapse collapse"
            :aria-labelledby="'flush-heading' + index"
            data-bs-parent="#accordionFlushCompetenceHoerbuch"
          >
            <div class="accordion-body">
              {{ skill.description }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useViewStore } from "../stores/ViewStore";

const viewStore = useViewStore();

const skills = ref([
  {
    header: "Lektorat",
    description:
      "Wir bieten eine professionelle Unterstützung sowie Beratung  bei der Rechtschreibung, Stilistik oder Gramatik.",
  },
  {
    header: "Sprecher & Sprecherin",
    description:
      "Unser Voice Pool bietet für jedes Hörbuch die passende Stimme. Ob Profi, Newcomer oder deine Lieblingssprecher:in. Wir machen es alles möglich!",
  },
  {
    header: "Übersetzung & Aussprache",
    description:
      "Neben dem Lektorat arbeiten wir mit professionellen Coaches, die bei der Aussprache & Grammatik  während der Aufnahme unterstützen und korrigieren.",
  },
  {
    header: "Sounddesign & Musik",
    description:
      "Wir schaffen Atmosphäre! Musik transportiert  Emotionen bei der Zuhörerschaft. Wir bieten erstklassige Musikauswahl und passendes Sound Design für ein noch intensiveres Hörerlebnis.",
  },
  {
    header: "Distribution & Vermarktung",
    description:
      "Durch unser breites Netzwerk an digitaler Distributoren können wir im Digitalvertrieb jedes Hörbuch vermarkten lassen.",
  },
  {
    header: "Cover Design",
    description:
      " Wir produzieren nicht nur  Audio, sondern auch tolle Cover Designs. Denn ein ansprechendes Hörbuch Cover ist entscheidend für die Vermarktung und darf neben einer tollen Produktion nicht fehlen.",
  },
]);
</script>

<style scoped>
.accordion-button::after {
  width: 1.8rem;
  height: 1.8rem;
  margin-left: auto;
  background-image: url("../assets/svg/plus-lg.svg") !important;
  background-size: 1.8rem;
}

.accordion-button:not(.collapsed)::after {
  background-image: url("../assets/svg/plus-lg.svg") !important;
  transform: rotate(45deg) !important;
}
.accordion-button {
  font-weight: 700;
  font-size: 1.5rem;
  background-color: rgb(255, 255, 255, 0.4);
}

.accordion-item {
  background-color: rgba(255, 255, 255, 0.3);
}

.accordion-body {
  background-color: rgba(255, 255, 255, 0.6);
}

.accordion-button:focus {
  outline: none;
  box-shadow: none;
}

.accordion-button:not(.collapsed) {
  color: black;
  /* background-color: transparent; */
  background-color: rgba(255, 255, 255, 0.7);
  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0
    var(--bs-accordion-border-color);
}

.accordion-button:not(.collapsed)::after {
  background-image: var(--bs-accordion-btn-icon);
  transform: var(--bs-accordion-btn-icon-transform);
}

.accordion-flush .accordion-item {
  border-right: 0;
  border-left: 0;
  border-bottom: 2px solid rgb(0, 0, 0);
  border-radius: 0;
}
.header-title {
  color: #fc4667;
  font-weight: 900;
  font-size: 3.1rem;
}
.block {
  position: relative;
  /* bottom: 0; */
  /* width: 100%; */
  /* height: 100%; */
  /* height: 1600px; */
}

.card-title {
  color: black !important;
  font-weight: 700;
}

.card-title-closed {
  color: black !important;
  font-weight: 700;
}

.card-body:hover {
  cursor: pointer;
  transition-duration: 0.5;
}

.card {
  height: 100%;
  border: none;
  background-color: rgb(249, 249, 249, 0.66);
}

video {
  width: 100%;
  height: 900px;
  object-fit: cover;
}
</style>
